var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_15_calendar_outline",
    "data-name": "#15_calendar_outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.26,220.08H83.72a1,1,0,0,1,0-2H315.26a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.21,
    y: 89.95,
    width: 170.43,
    height: 129.12,
    rx: 11.03,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,220.08H117.24a12,12,0,0,1-12-12V101a12,12,0,0,1,12-12H265.61a12,12,0,0,1,12,12V208.05A12,12,0,0,1,265.61,220.08ZM117.24,91a10,10,0,0,0-10,10V208.05a10,10,0,0,0,10,10H265.61a10,10,0,0,0,10-10V101a10,10,0,0,0-10-10Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,101V114.8H106.21V101a11,11,0,0,1,11-11H265.61A11,11,0,0,1,276.64,101Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,115.8H106.21a1,1,0,0,1-1-1V101a12,12,0,0,1,12-12H265.61a12,12,0,0,1,12,12V114.8A1,1,0,0,1,276.64,115.8Zm-169.43-2H275.64V101a10,10,0,0,0-10-10H117.24a10,10,0,0,0-10,10Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.46,
    y: 129.47,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,148.17H153.46a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1v17.7A1,1,0,0,1,171.17,148.17Zm-16.71-2h15.71v-15.7H154.46Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.57,
    y: 129.47,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,148.17H182.57a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1v17.7A1,1,0,0,1,200.28,148.17Zm-16.71-2h15.71v-15.7H183.57Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.68,
    y: 129.47,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.38,148.17h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1v17.7A1,1,0,0,1,229.38,148.17Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.79,
    y: 129.47,
    width: 17.7,
    height: 17.7,
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,148.17h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1v17.7A1,1,0,0,1,258.49,148.17Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.36,
    y: 156.36,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,175.06h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1v17.7A1,1,0,0,1,142.06,175.06Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.46,
    y: 156.36,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,175.06H153.46a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1v17.7A1,1,0,0,1,171.17,175.06Zm-16.71-2h15.71v-15.7H154.46Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.57,
    y: 156.36,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,175.06H182.57a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1v17.7A1,1,0,0,1,200.28,175.06Zm-16.71-2h15.71v-15.7H183.57Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.68,
    y: 156.36,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.38,175.06h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1v17.7A1,1,0,0,1,229.38,175.06Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.79,
    y: 156.36,
    width: 17.7,
    height: 17.7,
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,175.06h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1v17.7A1,1,0,0,1,258.49,175.06Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.36,
    y: 183.25,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,202h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1V201A1,1,0,0,1,142.06,202Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.46,
    y: 183.25,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,202H153.46a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1V201A1,1,0,0,1,171.17,202Zm-16.71-2h15.71v-15.7H154.46Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.57,
    y: 183.25,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,202H182.57a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.71a1,1,0,0,1,1,1V201A1,1,0,0,1,200.28,202Zm-16.71-2h15.71v-15.7H183.57Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.68,
    y: 183.25,
    width: 17.7,
    height: 17.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.38,202h-17.7a1,1,0,0,1-1-1v-17.7a1,1,0,0,1,1-1h17.7a1,1,0,0,1,1,1V201A1,1,0,0,1,229.38,202Zm-16.7-2h15.7v-15.7h-15.7Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.21,
    cy: 101.29,
    r: 4.69,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,107a5.69,5.69,0,1,1,5.68-5.69A5.69,5.69,0,0,1,148.21,107Zm0-9.38a3.69,3.69,0,1,0,3.68,3.69A3.69,3.69,0,0,0,148.21,97.6Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.99,
    y: 80.8,
    width: 6.42,
    height: 22.34,
    rx: 3.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,104.14A4.22,4.22,0,0,1,144,99.93V84a4.22,4.22,0,0,1,8.43,0V99.93A4.22,4.22,0,0,1,148.21,104.14Zm0-22.34A2.22,2.22,0,0,0,146,84V99.93a2.22,2.22,0,0,0,4.43,0V84A2.22,2.22,0,0,0,148.21,81.8Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.64,
    cy: 101.29,
    r: 4.69,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,107a5.69,5.69,0,1,1,5.69-5.69A5.69,5.69,0,0,1,234.64,107Zm0-9.38a3.69,3.69,0,1,0,3.69,3.69A3.69,3.69,0,0,0,234.64,97.6Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.43,
    y: 80.8,
    width: 6.42,
    height: 22.34,
    rx: 3.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,104.14a4.22,4.22,0,0,1-4.21-4.21V84a4.21,4.21,0,0,1,8.42,0V99.93A4.22,4.22,0,0,1,234.64,104.14Zm0-22.34A2.21,2.21,0,0,0,232.43,84V99.93a2.21,2.21,0,0,0,4.42,0V84A2.21,2.21,0,0,0,234.64,81.8Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,197.75a1.57,1.57,0,0,1-.37-.05,1.48,1.48,0,0,1-1-.88l-3-7.17a1.5,1.5,0,1,1,2.77-1.15l2.19,5.3,12.9-10.58a1.5,1.5,0,1,1,1.9,2.32l-14.46,11.87A1.51,1.51,0,0,1,160.78,197.75Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.26,114.61h4.45a4.2,4.2,0,0,1,4.2,4.2v67.32a0,0,0,0,1,0,0H104.06a0,0,0,0,1,0,0V118.82A4.2,4.2,0,0,1,108.26,114.61Z",
    transform: "translate(-71.87 110.79) rotate(-41.45)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,182.44h-.07a1,1,0,0,1-.68-.33L84,131.64a5.2,5.2,0,0,1,.45-7.35l3.34-2.94a5.2,5.2,0,0,1,7.34.45l44.56,50.47a1,1,0,0,1-.09,1.41L130,182.19A1,1,0,0,1,129.34,182.44ZM91.26,122.05a3.19,3.19,0,0,0-2.12.8l-3.33,2.94a3.19,3.19,0,0,0-.28,4.52L129.42,180l8.14-7.18-43.9-49.71A3.17,3.17,0,0,0,91.26,122.05Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.97 172.92 143.14 183.1 146.38 191.02 138.92 186.83 129.33 181.44 138.97 172.92",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.38,192a1,1,0,0,1-.49-.13l-17-9.58a1,1,0,0,1-.5-.77,1,1,0,0,1,.33-.85l9.64-8.52a1,1,0,0,1,.89-.22,1,1,0,0,1,.7.59l7.4,18.1a1,1,0,0,1-.26,1.13A1,1,0,0,1,146.38,192Zm-15.33-10.76,13.31,7.48-5.78-14.14Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.46 181.44 146.38 191.02 137.14 185.83 142.46 181.44",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.38,192a1,1,0,0,1-.49-.13l-9.24-5.19a1,1,0,0,1-.51-.78,1,1,0,0,1,.36-.86l5.32-4.39a1,1,0,0,1,1.56.39l3.92,9.58a1,1,0,0,1-.26,1.13A1,1,0,0,1,146.38,192Zm-7.48-6.35,5.46,3.07L142,183.08Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,201.18s-9.05-18.45-7.79-30.92c0,0,7.28,3.29,10.79,13,5.36,14.86,4.12,17.93,4.12,17.93Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.12,202.2h0l-7.12,0a1,1,0,0,1-.89-.56c-.38-.76-9.17-18.85-7.9-31.46a1,1,0,0,1,.5-.77,1,1,0,0,1,.91,0c.31.14,7.71,3.58,11.32,13.58,5.22,14.48,4.34,18.07,4.11,18.64A1,1,0,0,1,299.12,202.2Zm-6.48-2h5.61c0-1.48-.32-5.86-4.19-16.59a23.27,23.27,0,0,0-9-11.68C284.76,182.67,291.23,197.18,292.64,200.19Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.31,200.29s-6.8-26.31,3-43.93c0,0,5.63,6.44,7,22a39.31,39.31,0,0,1-4.07,21.52Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.31,201.29a1,1,0,0,1-1-.75A87,87,0,0,1,293.13,185c-.44-8.15.12-19.81,5.28-29.12a1,1,0,0,1,.77-.51,1,1,0,0,1,.86.34c.23.27,5.85,6.86,7.21,22.59a40,40,0,0,1-4.2,22.12,1,1,0,0,1-.79.49l-5.89.39Zm3.1-43c-7.51,15.3-3.31,36.59-2.33,41l4.49-.3a39.36,39.36,0,0,0,3.69-20.47C304.29,167.19,301,160.79,299.41,158.27Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.24,199.47s2.11-17.57,16.31-29c0,0,4.19,13.09-7.55,30.59Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,202l-.17,0-8.76-1.55a1,1,0,0,1-.82-1.1c.09-.73,2.32-18.11,16.67-29.69a1,1,0,0,1,.92-.18,1,1,0,0,1,.66.65c.18.55,4.2,13.75-7.67,31.45A1,1,0,0,1,308,202Zm-7.61-3.36,7.14,1.26c8.65-13.21,8-23.83,7.39-27.65C304.09,181.8,301,195.05,300.39,198.66Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.97 219.2 291.1 219.2 288.45 197.45 311.61 197.45 308.97 219.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,220.2H291.1a1,1,0,0,1-1-.88l-2.65-21.75a1,1,0,0,1,.25-.78,1,1,0,0,1,.75-.34h23.15a1,1,0,0,1,.75.34,1,1,0,0,1,.25.78L310,219.32A1,1,0,0,1,309,220.2Zm-17-2h16.09l2.41-19.75H289.58Z",
    fill: "#093f68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b0ba607b5fc0d853730c0c4af6678bdf.svg";
export { ForwardRef as ReactComponent };